import uuid from 'react-uuid'

if (!localStorage.getItem('fpguestuid')) {
  localStorage.setItem('fpguestuid', uuid())
}
export const fingerprint: string = localStorage.getItem('fpguestuid') || uuid()
console.log(fingerprint)
